import { useRef, useContext } from 'react';
import { Button, CenterScreenModal } from '../atoms'
import { 
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
  useAddIncidentExpenseFormModalContext,
} from '@/customHooks'
import { 
  IncidentDetailContext,
} from '@/contexts'
import { Col, Row } from 'react-grid-system';
import {
  CreateIncidentExpenseInput,
  useCreateIncidentExpenseMutation,
} from '@/graphql/generated';
import { AddIncidentExpenseFormControlled } from '../organism';

const textsData = {
  en: {
    title: 'Add an Incident Expense',
    confirmation: {
      create: {
        title: 'Expense has been created',
        description: (invoiceNumber: string) => `Expense with invoice number "${invoiceNumber}" has been created successfully`,
      },
    },
    button: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    }
  },
  es: {
    title: 'Crear un Gasto de Incidente',
    confirmation: {
      create: {
        title: 'Gasto creado con éxito',
        description: (invoiceNumber: string) => `El gasto con número de factura "${invoiceNumber}" fue creado con éxito`,
      },
    },
    button: {
      confirm: 'Aceptar',
      cancel: 'Volver'
    }
  }
}

export const AddIncidentExpenseFormModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const expenseDataRef = useRef<CreateIncidentExpenseInput | null>(null)
  
  const [createIncidentExpense, { loading }] = useCreateIncidentExpenseMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { incidentId, isOpen, closeModal } = useAddIncidentExpenseFormModalContext()
  
  const { open: openError } = useErrorHandlerContext()

  const incidentContext = useContext(IncidentDetailContext)

  const OnChangeHandle = (expenseData: CreateIncidentExpenseInput) => {
    expenseDataRef.current = expenseData
  }

  const onConfirmHandle = () => {
    if (!expenseDataRef.current) return
    
    if (!expenseDataRef.current.invoiceDate || (expenseDataRef.current.invoiceDate as string).trim() === '') {
      openError(new Error(userLanguage === 'es' ? 'La fecha es requerida' : 'Date is required'))
      return
    }
    
    if (!incidentId) {
      openError(new Error(userLanguage === 'es' ? 'ID de incidente no encontrado' : 'Incident ID not found'))
      return
    }
    
    createIncidentExpense({ 
      variables: {
        incidentExpenseInput: expenseDataRef.current,
        incidentId: incidentId,
      }
    })
    .then(() => {
      closeModal()
      confirmDialogModalOpen({
        title: texts.confirmation.create.title,
        description: texts.confirmation.create.description(expenseDataRef.current?.invoiceNumber ?? ''),
      })
      
      incidentContext?.setIncident(undefined)
      /* if (incidentId && incidentContext && incidentContext.incident) {
        const currentIncident = { ...incidentContext.incident }
        incidentContext.setIncident(undefined)
        queueMicrotask(() => {
          incidentContext.setIncident(currentIncident)
        })
      } */
    })
    .catch((error) => {
      closeModal()
      openError(error)
    })
  }
  
  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <AddIncidentExpenseFormControlled onChange={OnChangeHandle} />
      <Row justify='center' gutterWidth={32}>
        <Col xs='content'>
          <Button secondary onClick={closeModal} disabled={loading}>
            {texts.button.cancel}
          </Button>
        </Col>
        <Col xs='content'>
          <Button onClick={onConfirmHandle} isLoading={loading}>
            {texts.button.confirm}
          </Button>
        </Col>
      </Row>
    </CenterScreenModal>
  )
}
